import React, { useEffect, useRef } from 'react';
var SnippylyRecorderControlPanel = function (props) {
    var mode = props.mode, panelId = props.panelId, onRecordedData = props.onRecordedData, recordingCountdown = props.recordingCountdown, recordingTranscription = props.recordingTranscription, videoEditor = props.videoEditor, settingsEmbedded = props.settingsEmbedded, autoOpenVideoEditor = props.autoOpenVideoEditor, playVideoInFullScreen = props.playVideoInFullScreen, retakeOnVideoEditor = props.retakeOnVideoEditor;
    var ref = useRef();
    var onRecordedDataRef = useRef(onRecordedData);
    // Update the ref to always point to the latest callback function
    useEffect(function () {
        onRecordedDataRef.current = onRecordedData;
    }, [onRecordedData]);
    useEffect(function () {
        var element;
        var handleRecordedData = function (event) {
            if (onRecordedDataRef.current) {
                onRecordedDataRef.current(event === null || event === void 0 ? void 0 : event.detail);
            }
        };
        if (ref.current) {
            element = ref.current;
            if (element) {
                element.addEventListener('onRecordedData', handleRecordedData);
            }
        }
        return function () {
            if (element) {
                element.removeEventListener('onRecordedData', handleRecordedData);
            }
        };
    }, []);
    return (React.createElement("velt-recorder-control-panel", { ref: ref, mode: mode, "panel-id": panelId, "retake-on-video-editor": [true, false].includes(retakeOnVideoEditor) ? (retakeOnVideoEditor ? 'true' : 'false') : undefined, "recording-countdown": [true, false].includes(recordingCountdown) ? (recordingCountdown ? 'true' : 'false') : undefined, "recording-transcription": [true, false].includes(recordingTranscription) ? (recordingTranscription ? 'true' : 'false') : undefined, "video-editor": [true, false].includes(videoEditor) ? (videoEditor ? 'true' : 'false') : undefined, "settings-embedded": [true, false].includes(settingsEmbedded) ? (settingsEmbedded ? 'true' : 'false') : undefined, "auto-open-video-editor": [true, false].includes(autoOpenVideoEditor) ? (autoOpenVideoEditor ? 'true' : 'false') : undefined, "play-video-in-full-screen": [true, false].includes(playVideoInFullScreen) ? (playVideoInFullScreen ? 'true' : 'false') : undefined }));
};
export default SnippylyRecorderControlPanel;
